import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {inputProps, onConfirm, onCancel} = props;
    let {type, show, loading} = inputProps;
    let title = 'Хотите редактировать заказ?';
    let text = 'Заказ будет иметь статус \"черновик\"';

    if(type === 'error') title = 'Произошла ошибка!'
    if(type === 'error') text = '';

    return (
        <SweetAlert
            show={show}
            type={type}
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'default' ? true : false}
            confirmBtnText="Продолжить"
            cancelBtnText={type === 'default' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={() => loading ? false : onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                text
                ?
                <div className="sw-alert__body">{text}</div>
                : null
            }
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/EditOrder.js